import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { Newquestion } from './newquestion';

@NgModule({
  declarations: [
    Newquestion,
  ],
  imports: [
    IonicPageModule.forChild(Newquestion),
  ],
  exports: [
    Newquestion
  ]
})
export class NewquestionModule {}



// WEBPACK FOOTER //
// ./src/pages/newquestion/newquestion.module.ts